import { useState } from 'react'
import { useZxing } from 'react-zxing'
// import { usePlaySound } from '../../../hooks/usePlaySound'
// import sound from '../../../../assets/sounds/sound4.mp3'

export const useQr = (onChange: (value: string) => void) => {
  const [modalActive, setModalActive] = useState<boolean>(false)
  // const { playSound } = usePlaySound()

  const {
    ref,
  } = useZxing({
    onDecodeResult(result) {
      onChange(result.getText().trim().replaceAll('\x1D', ''))
      // playSound(sound)
      setModalActive(false)
    },
    paused: !modalActive,
  })

  const startScan = () => {
    setModalActive(true)
  }

  return { modalActive, setModalActive, ref, startScan }
}